module.exports = __webpack_public_path__ + "assets/img/22_284.2d7776f8.jpg";